module.exports = __webpack_public_path__ + "favicon.ico?4859e39ae6c0f1f428f2126a6bb32bd9";